module.exports = __webpack_public_path__ + "img/yizhanshi3.1c1d57bc.png";